export const GET_PING_MONITORS = "GET_PING_MONITORS";
export const GET_PING_MONITORS_SUCCESS = "GET_PING_MONITORS_SUCCESS";
export const GET_PING_MONITORS_FAIL = "GET_PING_MONITORS_FAIL";

export const GET_PING_MONITOR_DETAIL = "GET_PING_MONITOR_DETAILS";
export const GET_PING_MONITOR_DETAIL_SUCCESS = "GET_PING_MONITOR_DETAILS_SUCCESS";
export const GET_PING_MONITOR_DETAIL_FAIL = "GET_PING_MONITOR_DETAILS_FAIL";

export const EDIT_PING_MONITORS = "EDIT_PING_MONITORS";
export const EDIT_PING_MONITORS_SUCCESS = "EDIT_PING_MONITORS_SUCCESS";
export const EDIT_PING_MONITORS_FAIL = "EDIT_PING_MONITORS_FAIL";

export const ADD_PING_MONITORS = "ADD_PING_MONITOR";
export const ADD_PING_MONITORS_SUCCESS = "ADD_PING_MONITOR_SUCCESS";
export const ADD_PING_MONITORS_FAIL = "ADD_PING_MONITOR_FAIL";

export const MAP_ENDPOINT_TO_SERVICE = "MAP_ENDPOINT_TO_SERVICE";
export const MAP_ENDPOINT_TO_SERVICE_FAIL = "MAP_ENDPOINT_TO_SERVICE_FAIL";
export const MAP_ENDPOINT_TO_SERVICE_SUCCESS = "MAP_ENDPOINT_TO_SERVICE_SUCCESS";

export const GET_ENDPOINT_BY_SERVICE_ID = "GET_ENDPOINT_BY_SERVICE_ID";
export const GET_ENDPOINT_BY_SERVICE_ID_FAIL = "GET_ENDPOINT_BY_SERVICE_ID_FAIL"
export const GET_ENDPOINT_BY_SERVICE_ID_SUCCESS = "GET_ENDPOINT_BY_SERVICE_ID_SUCCESS";

export const GET_TIMESTAMPS = "GET_TIMESTAMPS";
export const GET_TIMESTAMPS_FAIL = "GET_TIMESTAMPS_FAIL";
export const GET_TIMESTAMPS_SUCCESS = "GET_TIMESTAMPS_SUCCESS";

export const DELETE_ENDPOINT = "DELETE_ENDPOINT";
export const DELETE_ENDPOINT_FAIL = "DELETE_ENDPOINT_FAIL"
export const DELETE_ENDPOINT_SUCCESS = "DELETE_ENDPOINT_SUCCESS"

export const TOGGLE_ENDPOINT = "TOGGLE_ENDPOINT"
export const TOGGLE_ENDPOINT_SUCCESS = "TOGGLE_ENDPOINT_SUCCESS"
export const TOGGLE_ENDPOINT_FAIL = "TOGGLE_ENDPOINT_FAIL"

export const GET_TIMESTAMPS_BY_SERVICE_ID = "GET_TIMESTAMPS_BY_SERVICE_ID";
export const GET_TIMESTAMPS_BY_SERVICE_ID_SUCCESS = "GET_TIMESTAMPS_BY_SERVICE_ID_SUCCESS";
export const GET_TIMESTAMPS_BY_SERVICE_ID_FAIL = "GET_TIMESTAMPS_BY_SERVICE_ID_FAIL";

export const GET_UPTIME_CHECK_FAILURES = "GET_UPTIME_CHECK_FAILURES";
export const GET_UPTIME_CHECK_FAILURES_SUCCESS = "GET_UPTIME_CHECK_FAILURES_SUCCESS";
export const GET_UPTIME_CHECK_FAILURES_FAIL = "GET_UPTIME_CHECK_FAILURES_FAIL";

export const VALIDATE_REGEX = "VALIDATE_REGEX";
export const VALIDATE_REGEX_SUCCESS = "VALIDATE_REGEX_SUCCESS"
export const VALIDATE_REGEX_FAIL = "VALIDATE_REGEX_FAIL"
